export default {
    '-': "-",
    actions: "Əməliyyatlar",
    actions_with_selected: "Seçilənlərlə əməliyyatlar",
    active: "Aktiv",
    add: "Əlavə et",
    add_attachment: "Əlavəni əlavə et",
    add_condition: "Şərt əlavə et",
    afternoon: "Gündüz",
    all: "Hamısı",
    app_is_in_maintenance_mode: "Proqramda texniki işlər aparılır. Tezliklə geri qayıdacağıq",
    are_you_sure_you_want_to_delete: "Siz həqiqətən materialı silmək istəyirsiniz?",
    are_you_sure_you_want_to_logout: "Siz həqiqətən çıxmaq istəyirsiniz?",
    assistant_id: "köməkçi",
    authorization: "Avtorizasiya",
    authorize_in_system: "Sistemə daxil olun",
    azerbaijani: "Azərbaycanca",
    balance: "Depozit",
    cancel: "Ləğv et",
    cancel_verb: "Ləğv et",
    change: "Dəyişdir",
    change_password: "Şifrəni dəyişdir",
    comment: "Şərh",
    confirm_deletion: "Silinməni təsdiq edirsiniz?",
    contacts: "Əlaqələr",
    contains: "Əhatə edir",
    continue: "Davam et",
    credit: "Kredit",
    currency: "Valyuta",
    custom_role_rights_updated: "Rol hüquqları yeniləndi",
    delete: "Sil",
    dentistry: "Stomatologiya",
    do_not_save: "qənaət etməyin",
    does_not_equal: "Bərabər deyil",
    done: "Hazırdır",
    down: "Aşağı",
    edit: "Redaktə et",
    egisz_send_error: "TƏBİB-ə göndərmə xətası",
    egisz_send_success: "TƏBİB-ə uğurla göndərildi",
    email: "Email",
    email_required_for_password_reset: "Bu istifadəçinin şifrəsini sıfırlamaq üçün onun e-poçtu daxil edilməlidir",
    end: "Son",
    english: "İngilis",
    enter_username_to_reset_password: "Şifrəni sıfırlamaq keçidini almaq üçün istifadəçi adınızı daxil edin",
    equals: "Bərabərdir",
    error: "Xəta",
    error_message: "Nəsə səhv getdi, əməliyyat uğurla başa çatmadı",
    evening: "Axşam",
    excel: "Excel",
    exported_patients_to_excel: "Xəstələri Excelə yüklədi",
    exported_report_to_excel: "Hesabatı Excelə yüklədi",
    fact: "Fakt",
    family_account_member_toggled: "Ailə hesabı üzvünün aktivliyini dəyişdi",
    family_account_updated: "Ailə hesabının tərkibini yenilədi",
    file: "Fayl",
    file_does_not_exist: "Fayl tapılmadı",
    file_size_is_too_big: "Faylın həcmi çox böyükdür",
    filled: "Doldurulmuşdur",
    filled_not_signed: "Doldurulmuş / imzalanmamış",
    filter: "Filter",
    finish: "Tamamla",
    finishing_operation: "Əməliyyatı başa çatdırma",
    forgot_password: "Şifrəni unutmusunuz?",
    from_to: "{from}-dan {to}-a",
    general_cost: "Ümumi xərc",
    general_medicine: "Ümumi tibb",
    general_slogan: "Müasir klinikanı idarə etmək üçün bulud həlli",
    hide: "Gizlət",
    hide2: "Gizlət",
    home: "Əsas səhifə",
    image: "Şəkil",
    import: "İdxal",
    in_interval: "Aralıqda",
    input_field: "Mətn daxil etmək sahəsi",
    integration: "İnteqrasiya",
    invalid_reset_link: "Bu şifrə sıfırlama keçidi etibarsızdır və ya vaxtı bitib",
    kazakh: "Qazax",
    kyrgyz: "Qırğız",
    KZT: "KZT",
    language: "Dil",
    less: "Daha az",
    links: "Linklər",
    load_more: "Daha çox yüklə",
    logged: "Səlahiyyətli",
    logged_out: "Sistemdən çıxdı",
    login: "Giriş",
    login_disclaimer: "DENTIST PLUS sisteminə girişi davam etdirməklə siz öz şəxsi hesabınızdan istifadə etdiyinizi təsdiqləyir və hesab məlumatlarınızdan istifadə etməklə edilən hərəkətlərə görə məsuliyyəti öz üzərinizə götürürsünüz. Hesab məlumatlarının üçüncü şəxslərə ötürülməsi qadağandır.",
    login_failed: "Sistemə giriş cəhdi uğursuz oldu",
    login_locked_out: "Giriş bloklandı (çox cəhd)",
    login_or_pass_incorrect: "Giriş və ya şifrə səhvdir",
    logout: "Çıxış",
    main: "Əsas",
    message: "Mesaj",
    module_unavailable: "Modul mövcud deyil",
    months: "Aylar",
    more: "Daha çox",
    more_2: "Daha çox",
    morning: "Səhər",
    must_change_password_notice: "Davam etmək üçün şifrənizi dəyişməlisiniz",
    name: "Ad",
    new_password: "Yeni şifrə",
    no: "Xeyr",
    no_data_available: "Hələlik məlumat yoxdur",
    nonactive: "Aktiv deyil",
    not_enough_rights_for_this_operation: "Bu əməliyyat üçün kifayət qədər hüququnuz yoxdur",
    not_filled: "Doldurulmayıb",
    nothing_found: "Heç nə tapılmadı",
    old_password: "Köhnə şifrə",
    on_page: "Səhifədə",
    page_not_found: "Səhifə tapılmadı",
    password: "Şifrə",
    password_changed: "Şifrə dəyişdirildi",
    password_confirm: "Şifrəni təsdiq et",
    password_reset_link_sent: "Əgər bu istifadəçi adı ilə hesab varsa, onun e-poçtuna şifrə sıfırlama keçidi göndərildi",
    password_reset_failed: "Şifrənin sıfırlanması cəhdi uğursuz oldu",
    password_reset_requested: "Şifrənin sıfırlanmasını tələb etdi",
    password_reset_succeeded: "Şifrəni uğurla sıfırladı",
    passwords_do_not_match: "Şifrələr uyğun gəlmir",
    patient_search: "Xəstə axtarışı",
    patient_tags_updated: "Xəstənin etiketlərini yenilədi",
    payment_expires_at: "Ödəniş müddəti bitir",
    phone: "Telefon",
    photo: "Foto",
    price: "Qiymət",
    print_noun: "Çap",
    professional: "Peşəkar",
    profile: "Profil",
    program: "Proqram",
    refresh: "Yenilə",
    registration: "Qeydiyyat",
    requirements: "Tələblər",
    reset: "Sıfırla",
    reset_password: "Şifrəni sıfırla",
    reset_password_email_note: "İstifadəçiyə yeni şifrə təyin etmək üçün e-poçtuna keçid göndəriləcək",
    reset_success: "Sıfırlama məktubu email ünvanınıza göndərildi",
    role: "Rol",
    russian: "Rus",
    save: "Yadda saxla",
    search: "Axtar",
    select: "Seç",
    send_reset_link: "Keçidi göndər",
    sent: "Göndərildi",
    session_revoked: "Sessiyanı ləğv etdi",
    sessions_revoked: "Digər bütün sessiyaları ləğv etdi",
    settings: "Parametrlər",
    show: "Göstər",
    show_full: "Tam göstər",
    signin: "Daxil ol",
    slogan: "Müasir stomatologiya idarəçiliyi üçün bulud həlli",
    sorting: "Sıralama",
    staff_rights_updated: "İşçinin hüquqları yeniləndi",
    staff_role_updated: "İşçinin rolu yeniləndi",
    start: "Başla",
    start_noun: "Başlamaq",
    status: "Status",
    subscription_sum: "Abunə məbləği",
    success_message: "Əməliyyat uğurla tamamlandı",
    sum: "Məbləğ",
    system: "Sistemli",
    table_search: "Cədvəl üzrə axtarış",
    tech_specialist: "Texnik",
    text: "Mətn",
    there_are_unsaved_changes: "Saxlanmamış dəyişikliklər var",
    this_module_is_not_in_tariff: "Bu modul Free tarifinə daxil deyil, Standard və ya Premium tarifinə keçmək lazımdır və siz Dentist Plus proqramının geniş funksiyalarına çıxış əldə edəcəksiniz.",
    title: "Başlıq",
    to_top: "Yuxarı",
    today: "Bu gün",
    total: "Cəmi",
    translation: "Tərcümə",
    unknown: "Naməlum",
    upload: "Yüklə",
    web: "Web",
    who_has_access: "Kimin girişi var",
    wrong_file_format: "Yanlış fayl formatı",
    yes: "Bəli"
}
